import { StorageManager } from "../managers/storageManager";
import { Router } from "@angular/router";

export class BaseMenuComponent {
    constructor(protected storageManager: StorageManager, protected router: Router) {

    }

    protected toggleButton: any;
    public sidebarVisible: boolean;

    public logout(): void {
        this.storageManager.logout();

        this.router.navigate(['/auth/login']);
    }

    public async goToProfile(): Promise<void> {
        this.sidebarToggle();
        this.router.navigate(['management/agent', { id: (await this.storageManager.getCurrentUser()).Id }]);
    }

    public sidebarToggle(): void {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];

        if (this.sidebarVisible == false) {
            setTimeout(function () {
                toggleButton.classList.add('toggled');
            }, 500);
            body.classList.add('nav-open');
            this.sidebarVisible = true;
        } else {
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            body.classList.remove('nav-open');
        }
    }
}


// WEBPACK FOOTER //
// ./app/common/menu/baseMenuComponent.ts